import React, { useEffect, useRef, useState } from "react";
import { DisplayView } from "./DisplayView";
import styles from "./styles/displaystyle.module.css";

import apiService from "../../services/apiService";
import { RaceDTO } from "../../interfaces/RaceDTO";
import moment from "moment";
import { DisplayProvider } from "../../services/displayservices/DisplayProvider";

const Display = () => {
  const [raceID, setRaceID] = useState<number | null>(null);
  const [raceDate,setRaceDate] = useState<string | null>(null);

  let raceDateref = useRef<string | null>(raceDate);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const raceid = params.get("raceid");
    let intervalId:any;
    intervalId = setInterval(() => {
      let dat = moment().format("yyyy-MM-DD");
      if (raceDateref !== null){
        if (dat !== raceDateref.current){
          setRaceDate(dat);
        }
      }
      //checkLastPass();
    },1000*60);
    if (raceid === null && raceID === null) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position.coords);
        },
        (error) => {
          console.error("Error getting user location:", error);
        }
      );
      const fetchData = async () => {
        try {
          const result = await apiService.get<RaceDTO[]>(
            "/GetRaces/?ApiKey=#apikey#&TimingProviderKey=0a9afd9be94c9f567d86fa48c918bcd9"
          );
          // console.log(JSON.stringify(result));
          result.map((obj) => {
            let racedate = moment(obj.RaceDate);
            let today = moment("2023-10-29T10:00:00");
            if (today.isSame(racedate,"date")){
                console.log("is the same dae");
                setRaceID(obj.Id);
                return false;
            }
            setRaceDate(today.format("yyyy-MM-DD"));

            console.log(obj.RaceDate);
          });
          document.title = "LS: Display";
        } catch (error) {
          console.error("Error fetching data", error);
        }
      };
      fetchData();
    } else if (raceid !== null) {
      setRaceID(parseInt(raceid));
    }

    return () => {
      if (intervalId){
        clearInterval(intervalId);
      }
      
    }
  }, []);

  useEffect(() => {
    raceDateref.current = raceDate;
  },[raceDate]);

  return (
    <DisplayProvider>
    <div className={styles.display}>
      <DisplayView raceid={raceID} />
    </div>
    </DisplayProvider>
  );
};

export default Display;
